(function () {
  var trackedVideos = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  var ICON_UNMUTED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>';
  var ICON_MUTED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M23 9l-6 6"/><path d="M17 9l6 6"/></svg>';

  function trackView(id) {
    var url = window.shCommunityTrackUrl;
    if (!id || !url) return;
    // Deliberately not using navigator.sendBeacon here: it fires cross-origin
    // (this endpoint isn't same-origin with the storefront) and the response
    // is unreadable by design, which made a real Origin-handling failure
    // silently invisible in testing. A keepalive fetch gives the same
    // "survives page navigation" guarantee, but request delivery was
    // verified end-to-end, so use that instead.
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({ id: id }),
      keepalive: true,
      headers: { 'Content-Type': 'application/json' }
    }).catch(function () {});
  }

  function deterDownload(video) {
    // Best-effort deterrents only — casual right-click-save / drag-save, not
    // a real DRM barrier (anyone using devtools/network tab can still fetch
    // the source file; that's inherent to how <video> has to work).
    video.setAttribute('controlsList', 'nodownload noremoteplayback');
    video.setAttribute('disablePictureInPicture', '');
    video.setAttribute('draggable', 'false');
    video.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    video.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function setupCustomControls(media, video) {
    video.removeAttribute('controls');
    deterDownload(video);
    var muteBtn = document.createElement('button');
    muteBtn.type = 'button';
    muteBtn.className = 'sh-vid-mute';
    function updateIcon() {
      muteBtn.innerHTML = video.muted ? ICON_MUTED : ICON_UNMUTED;
      muteBtn.setAttribute('aria-label', video.muted ? (window.SH_I18N && window.SH_I18N.video_unmute_label || 'Geluid aan') : (window.SH_I18N && window.SH_I18N.video_mute_label || 'Dempen'));
    }
    muteBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = !video.muted;
      updateIcon();
    });
    video.addEventListener('click', function () {
      if (video.paused) video.play(); else video.pause();
    });
    updateIcon();
    media.appendChild(muteBtn);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sh-video-trigger]');
    if (!btn) return;
    var media = btn.closest('.sh-media') || btn.parentElement;
    var tpl = media.querySelector('template[data-sh-video-src]');
    if (!tpl) return;
    var trackId = media.getAttribute('data-track-id');
    var frag = tpl.content.cloneNode(true);
    btn.replaceWith(frag);

    var video = media.querySelector('video');
    if (video) {
      setupCustomControls(media, video);
      // Start playback synchronously, in the SAME tap that inserted the
      // video, so mobile browsers recognize it as a user-gesture-triggered
      // play() call. Without this, the video only had the HTML `autoplay`
      // attribute to rely on, which mobile browsers evaluate asynchronously
      // (once metadata loads) and therefore do NOT treat as gesture-
      // authorized for unmuted media — so it silently failed to start, and
      // a second tap was needed to hit this video's own click-to-play
      // listener below. Swallow the promise rejection for browsers that
      // still decline (e.g. no prior interaction with the domain at all).
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
      if (trackId) {
        video.addEventListener('timeupdate', function onTime() {
          if (trackedVideos && trackedVideos.has(video)) return;
          if (video.currentTime >= 2) {
            if (trackedVideos) trackedVideos.add(video);
            trackView(trackId);
            video.removeEventListener('timeupdate', onTime);
          }
        });
      }
    }
  });

  // Only one of these videos should ever play at a time. 'play' doesn't
  // bubble, so this has to listen on the capturing phase to catch it.
  document.addEventListener(
    'play',
    function (e) {
      if (!e.target || !e.target.classList || !e.target.classList.contains('sh-vid-el')) return;
      document.querySelectorAll('video.sh-vid-el').forEach(function (video) {
        if (video !== e.target && !video.paused) video.pause();
      });
    },
    true
  );
})();
